<template>
	<div>
		<el-container>
			<el-container>
				<el-main>
					<div class="search-box clearfix">
						<el-form class="form-main" ref="searchForm" :model="searchForm" size="mini" inline label-width="80px" label-position="right">
							<span>
								<el-form-item label="昵称" property="nickname">
									<el-input
										v-model="searchForm.nickname"
										placeholder="输入昵称进行搜索"
										clearable
										@keyup.enter.native="getCustomerList"
									>
									</el-input>
								</el-form-item>
							</span>
							<span>
								<el-form-item label="openid" property="openid">
									<el-input
										v-model="searchForm.openid"
										placeholder="输入openid进行搜索"
										clearable
										@keyup.enter.native="getCustomerList"
									>
									</el-input>
								</el-form-item>
							</span>

							<div class="search-box-button search-button search_box_button_right">
								<el-button size="mini" type="primary" @click.native.prevent="getCustomerList">查 询</el-button>
								<el-button size="mini"  @click="resetSearchForm">重 置</el-button>
							</div>

						</el-form>
					</div>
					<hr class="search_border">
					<div class="search_tools_div">
						<div class="search_tools_text" @click="handleSearchToolsTextClick">数据列表</div>
						<!-- <div class="search-tools">
							<el-button type="primary" @click="addHandle">新增</el-button>
						</div> -->
					</div>
					<el-table
					  v-loading='loading'
					  ref="multipleTable"
					  :data="tableData"
					  tooltip-effect="dark"
					  :height="tableHeight"
					  border
					  stripe
					  @selection-change="handleSelectionChange">
						<el-table-column type="index" width="80" align="center" label="编号"></el-table-column>
						<el-table-column prop="nickname" label="昵称" show-overflow-tooltip align="center"></el-table-column>
						<el-table-column prop="openid" label="openid"  align="center"></el-table-column>
						<el-table-column prop="points" label="累计结余时间数" align="center" />
						<el-table-column prop="isPush" label="订阅状态" align="center" >
							<template slot-scope="scope">
								<el-tag v-if="scope.row.isPush == 1" type="primary">已订阅</el-tag>
								<el-tag v-else type="warning">未订阅</el-tag>
							</template>
						</el-table-column>
						<!-- <el-table-column prop="pointsAcc" label="结余时间数jiami" align="center" /> -->
						<el-table-column prop="remark" label="备注" align="center" />
						<el-table-column prop="createTime" label="注册时间" align="center" />

						<!-- <el-table-column
						  label="状态"
						  align="center"
						  show-overflow-tooltip
						>
							<template slot-scope="scope">
								<el-tag
								  :type="scope.row.statusFlag == 1 ? 'primary' : scope.row.statusFlag == 2 ? 'info' : 'warning'"
								  disable-transitions>{{ scope.row.statusFlag == 1 ? '生效中' : scope.row.statusFlag == 2 ? '已过期' : '未生效' }}
								</el-tag>
							</template>
						</el-table-column> -->

						<el-table-column
						  prop="icon"
						  fixed="right"
						  align="center"
						  width="350"
						  label="操作">

							<template slot-scope="scope">
								<el-button type="text" @click="pointsHandle(scope.row)">结余时间操作</el-button>

								<el-divider direction="vertical" />
								<el-button type="text" @click="orderRecordHandle(scope.row)">订单记录</el-button>
								<el-divider direction="vertical" />
								<el-button type="text" @click="detailHandle(scope.row)">积分明细</el-button>
								<el-divider direction="vertical" v-if="showTuisong" />
								<el-button type="text" v-if="showTuisong" @click="tuisongHandle(scope.row)">测试推送</el-button>
								<!-- <el-divider direction="vertical" /> -->
								<!-- <el-button type="text" @click="editHandle(scope.row.id)">编辑</el-button> -->
							</template>
						</el-table-column>

					</el-table>

					<el-pagination
					  @size-change="handleSizeChange"
					  @current-change="handleCurrentChange"
					  layout="total, sizes, prev, pager, next, jumper"
					  :page-sizes="[10, 20, 50, 100]"
					  :current-page="current"
					  :page-size="size"
					  :total="total">
					</el-pagination>
				</el-main>
			</el-container>
		</el-container>

		<!--新增对话框-->
<!-- 		<el-dialog
		  :title="title"
		  :visible.sync="dialogVisible"
		  width="700px"
		  :before-close="handleClose"
		  :close-on-click-modal="false">

			<el-form :model="editForm" :rules="editFormRules" ref="editForm" label-width="100px">

				<el-form-item label="配额名称" prop="quotaName">
					<el-input v-model="editForm.quotaName" placeholder="请输入配额名称" autocomplete="off"></el-input>
				</el-form-item>

				<el-form-item label="配额" prop="quota">
					<el-input v-model="editForm.quota" placeholder="请输入配额（度/床位）" autocomplete="off"></el-input>
				</el-form-item>

				<el-form-item label="生效日期" prop="startDate">
					<el-date-picker
						v-model="editForm.startDate"
						type="date"
						format="yyyy-MM-dd"
						value-format="yyyy-MM-dd"
						placeholder="请选择生效日期">
					</el-date-picker>
				</el-form-item>

			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="resetForm('editForm')">取 消</el-button>
				<el-button type="primary" @click="submitForm('editForm')">确 定</el-button>
			</div>
		</el-dialog> -->
		
		<!--结余时间操作对话框-->
		<el-dialog
		  :title="jfTitle"
		  :visible.sync="jfDialogVisible"
		  width="700px"
		  :before-close="handleJfClose"
		  :close-on-click-modal="true">
			<el-form :model="jfForm" :rules="jfFormRules" ref="jfForm" label-width="100px">
				<el-form-item label="操作类型" prop="points">
					<el-radio-group v-model="jfForm.type">
						<el-radio label="发放">发放</el-radio>
						<el-radio label="扣除">扣除</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="操作结余时间" prop="points">
					<el-input type="number" min="1" v-model="jfForm.points" placeholder="请输入结余时间（请填写正整数）" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="备注" prop="remark">
					<el-input v-model="jfForm.remark" placeholder="请输入备注" autocomplete="off"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="resetForm('jfForm')">取 消</el-button>
				<el-button type="primary" @click="submitJfForm('jfForm')">确 定</el-button>
			</div>
		</el-dialog>

		<!--结余时间明细对话框-->
		<el-dialog
		  :title="detailTitle"
		  :visible.sync="detailDialogVisible"
		  width="900px"
		  top="5vh"
		  :before-close="handleDetailClose"
		  :close-on-click-modal="false">
			<!-- 搜索区域 -->
			<div class="search-box clearfix">
				<el-form class="form-main" ref="detailSearchForm" :model="detailSearchForm" size="mini" inline label-width="100px" label-position="right">
					<el-form-item label="日期范围">
						<el-date-picker
							v-model="detailDateRange"
							type="datetimerange"
							range-separator="至"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
							format="yyyy-MM-dd HH:mm:ss"
							value-format="yyyy-MM-dd HH:mm:ss"
							:default-time="['00:00:00', '23:59:59']"
							style="width: 400px;"
							@change="searchDetailList"
						>
						</el-date-picker>
					</el-form-item>
					<div class="search-box-button search-button search_box_button_right">
						<el-button size="mini" type="primary" @click.native.prevent="searchDetailList">搜 索</el-button>
						<el-button size="mini" @click="resetDetailSearchForm">重 置</el-button>
					</div>
				</el-form>
			</div>
			<hr class="search_border">
			<!-- 表格 -->
			<el-table
			  v-loading='detailLoading'
			  :data="detailTableData"
			  tooltip-effect="dark"
			  border
			  stripe
			  style="margin-top: 20px;">
				<el-table-column type="index" width="60" align="center" label="编号"></el-table-column>
				<el-table-column prop="type" label="类型" align="center" width="120">
					<template slot-scope="scope">
						<el-tag v-if="scope.row.type == 1" type="warning">人工扣除</el-tag>
						<el-tag v-else-if="scope.row.type == 2" type="success">人工补贴</el-tag>
						<el-tag v-else-if="scope.row.type == 3" type="info">消费</el-tag>
						<el-tag v-else-if="scope.row.type == 4" type="primary">结余</el-tag>
						<span v-else>{{ scope.row.type }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="points" label="结余时间" align="center" width="120"></el-table-column>
				<el-table-column prop="remark" label="备注" align="center" show-overflow-tooltip></el-table-column>
				<el-table-column prop="createTime" label="操作时间" align="center" width="180"></el-table-column>
				<el-table-column prop="createTime" label="操作" align="center" width="100">
					<template slot-scope="scope">
						<el-button type="text" v-if="scope.row.orderNo" @click="viewDetailHandle(scope.row)">查看详情</el-button>
					</template>
				</el-table-column>
			</el-table>
			<!-- 分页 -->
			<el-pagination
			  @size-change="handleDetailSizeChange"
			  @current-change="handleDetailCurrentChange"
			  layout="total, sizes, prev, pager, next, jumper"
			  :page-sizes="[10, 20, 50, 100]"
			  :current-page="detailCurrent"
			  :page-size="detailSize"
			  :total="detailTotal"
			  style="margin-top: 20px; float: right;">
			</el-pagination>

			<div slot="footer" style="margin-top: 10px;" class="dialog-footer">
				<el-button @click="handleDetailClose">关 闭</el-button>
			</div>
		</el-dialog>

		<!-- 订单详情弹窗 -->
		<el-dialog
			title="订单详情"
			:visible.sync="orderDetailDialogVisible"
			width="800px"
			top="10vh"
			:before-close="closeOrderDetailDialog"
		>
			<div v-if="orderDetail" class="order-detail-container">
				<!-- 订单基本信息 -->
				<div class="detail-section">
					<div class="section-title">
						<i class="el-icon-document"></i>
						<span>订单信息</span>
					</div>
					<el-row :gutter="20" class="detail-row">
						<el-col :span="24">
							<div class="detail-item">
								<span class="detail-label">支付订单号：</span>
								<span class="detail-value">{{ clickRow.outTradeNo || '-' }}</span>
							</div>
						</el-col>
					</el-row>
					<el-row :gutter="20" class="detail-row">
						<el-col :span="12">
							<div class="detail-item">
								<span class="detail-label">openId：</span>
								<span class="detail-value">{{ clickRow.openid || '-' }}</span>
							</div>
						</el-col>
						<el-col :span="12">
							<div class="detail-item">
								<span class="detail-label">订单号：</span>
								<span class="detail-value">{{ clickRow.orderNo || '-' }}</span>
							</div>
						</el-col>
					</el-row>
					<el-row :gutter="20" class="detail-row">
						<el-col :span="12">
							<div class="detail-item">
								<span class="detail-label">设备位置：</span>
								<span class="detail-value">{{ orderDetail.device_tags || '-' }}</span>
							</div>
						</el-col>
						<el-col :span="12">
							<div class="detail-item">
								<span class="detail-label">端口号：</span>
								<span class="detail-value">{{ orderDetail.port || '-' }}</span>
							</div>
						</el-col>
					</el-row>
					<el-row :gutter="20" class="detail-row">
						<el-col :span="12">
							<div class="detail-item">
								<span class="detail-label">支付费用：</span>
								<span class="detail-value highlight" v-if="clickRow.amount">¥{{ formatAmount(clickRow.amount || 0) }}</span>
								<span class="detail-value highlight" v-if="clickRow.deductMinutes && clickRow.amount">+</span>
								<span class="detail-value highlight" v-if="clickRow.deductMinutes">{{ clickRow.deductMinutes ? clickRow.deductMinutes + '结余时间' : '-' }}</span>
							</div>
						</el-col>
						<el-col :span="12">
							<div class="detail-item">
								<span class="detail-label">支付状态：</span>
								<el-tag v-if="clickRow.paymentStatus == 1" type="success">已支付</el-tag>
								<el-tag v-else type="danger">未支付</el-tag>
							</div>
						</el-col>
					</el-row>
					<el-row :gutter="20" class="detail-row">
						<el-col :span="12">
							<div class="detail-item">
								<span class="detail-label">下单时长：</span>
								<span class="detail-value">{{ clickRow.chargingMinutes || '0' }}</span>
								<span class="detail-label">分钟</span>
							</div>
						</el-col>
						<el-col :span="12">
							<div class="detail-item">
								<span class="detail-label">下单时间：</span>
								<span class="detail-value">{{ clickRow.createTime || '-' }}</span>
							</div>
						</el-col>
					</el-row>
				</div>

				<!-- 充电时间信息 -->
				<div class="detail-section">
					<div class="section-title">
						<i class="el-icon-time"></i>
						<span>充电记录</span>
					</div>
					<el-row :gutter="20" class="detail-row">
						<el-col :span="12">
							<div class="detail-item">
								<span class="detail-label">实时功率：</span>
								<span class="detail-value">{{ orderDetail.power || '0' }}W
									<el-button title="实时功率曲线图" type="text" icon="el-icon-data-line" @click="togglePowerChart" style="margin-left: 20px;"></el-button>
								</span>
							</div>
						</el-col>
						<el-col :span="12">
							<div class="detail-item">
								<span class="detail-label">消耗电量：</span>
								<span class="detail-value">{{ orderDetail.elec || '0' }}度</span>
							</div>
						</el-col>
					</el-row>
					<el-row :gutter="20" class="detail-row">
						<el-col :span="12">
							<div class="detail-item">
								<span class="detail-label">充电状态：</span>
								<el-tag v-if="orderDetail.is_running == 1" type="primary">充电中</el-tag>
								<el-tag v-else type="info">充电结束</el-tag>
							</div>
						</el-col>
						<el-col :span="12">
							<div class="detail-item">
								<span class="detail-label">实际充电时长：</span>
								<span class="detail-value">{{ orderDetail.is_running == 1 ? orderDetail.minute || '-' : orderDetail.minute}}</span>
								<span class="detail-label">分钟</span>
							</div>
						</el-col>
					</el-row>
					<el-row :gutter="20" class="detail-row">
						<el-col :span="12">
							<div class="detail-item">
								<span class="detail-label">开始充电时间：</span>
								<span class="detail-value">{{ orderDetail.start_date || '-' }}</span>
							</div>
						</el-col>
						<el-col :span="12">
							<div class="detail-item">
								<span class="detail-label">结束充电时间：</span>
								<span class="detail-value">{{ orderDetail.end_date || '-' }}</span>
							</div>
						</el-col>
					</el-row>
					<el-row :gutter="20" v-if="orderDetail.is_running == 1" class="detail-row">
						<el-col :span="12">
							<div class="detail-item">
								<span class="detail-label">已充电时长：</span>
								<span class="detail-value">{{ getChargedDuration() }}分钟</span>
							</div>
						</el-col>
						<el-col :span="12">
							<div class="detail-item">
								<span class="detail-label">剩余时长：</span>
								<span class="detail-value">{{ getRemainingDuration() }}分钟</span>
							</div>
						</el-col>
					</el-row>
					<el-row v-if="orderDetail.is_running != 1" :gutter="20" class="detail-row">
						<el-col :span="24">
							<div class="detail-item">
								<span class="detail-label">结束原因：</span>
								<span class="detail-value highlight">{{ orderDetail.reason >= 0 ? reasonArr.find(item => item.value == orderDetail.reason).label : '-' }}</span>
							</div>
						</el-col>
					</el-row>
				</div>

				<!-- ECharts container -->
				<div v-if="showPowerChart" ref="powerChart" style="width: 100%; height: 300px; margin-top: 20px;"></div>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="closeOrderDetailDialog">关 闭</el-button>
			</div>
		</el-dialog>

		<!--订单记录对话框-->
		<el-dialog
		  :title="orderRecordTitle"
		  :visible.sync="orderRecordDialogVisible"
		  width="1200px"
		  top="5vh"
		  :before-close="handleOrderRecordClose"
		  :close-on-click-modal="false">
			<!-- 搜索区域 -->
			<div class="search-box clearfix">
				<el-form class="form-main" ref="orderRecordSearchForm" :model="orderRecordSearchForm" size="mini" inline label-width="100px" label-position="right">
					<el-form-item label="日期">
						<el-date-picker
							v-model="orderRecordDate"
							type="date"
							placeholder="选择日期"
							format="yyyy-MM-dd"
							value-format="yyyy-MM-dd"
							style="width: 200px;"
							@change="searchOrderRecordList"
						>
						</el-date-picker>
					</el-form-item>
					<div class="search-box-button search-button search_box_button_right">
						<el-button size="mini" type="primary" @click.native.prevent="searchOrderRecordList">搜 索</el-button>
						<el-button size="mini" @click="resetOrderRecordSearchForm">重 置</el-button>
					</div>
				</el-form>
			</div>
			<hr class="search_border">
			<!-- 表格 -->
			<el-table
			  v-loading='orderRecordLoading'
			  :data="orderRecordTableData"
			  tooltip-effect="dark"
			  border
			  stripe
			  style="margin-top: 20px;">
				<el-table-column type="index" width="60" align="center" label="编号"></el-table-column>
				<el-table-column prop="orderNo" label="订单号" align="center" width="200" show-overflow-tooltip></el-table-column>
				<el-table-column prop="outTradeNo" label="支付订单号" align="center" width="200" show-overflow-tooltip></el-table-column>
				<el-table-column prop="chargingMinutes" label="下单时长(分钟)" align="center" width="120"></el-table-column>
				<el-table-column prop="amount" label="支付费用(元)" align="center" width="120">
					<template slot-scope="scope">
						<span v-if="scope.row.amount">¥{{ formatAmount(scope.row.amount) }}</span>
						<span v-else>-</span>
					</template>
				</el-table-column>
				<el-table-column prop="deductMinutes" label="扣除结余时间" align="center" width="120">
					<template slot-scope="scope">
						<span v-if="scope.row.deductMinutes">{{ scope.row.deductMinutes }}</span>
						<span v-else>-</span>
					</template>
				</el-table-column>
				<el-table-column prop="paymentStatus" label="支付状态" align="center" width="100">
					<template slot-scope="scope">
						<el-tag v-if="scope.row.paymentStatus == 1" type="success">已支付</el-tag>
						<el-tag v-else type="danger">未支付</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="createTime" label="下单时间" align="center" width="180"></el-table-column>
				<el-table-column prop="chargingOrderNo" label="操作" align="center" width="100" fixed="right">
					<template slot-scope="scope">
						<el-button type="text" v-if="scope.row.chargingOrderNo" @click="viewOrderRecordDetail(scope.row)">查看详情</el-button>
					</template>
				</el-table-column>
			</el-table>
			<!-- 分页 -->
			<el-pagination
			  @size-change="handleOrderRecordSizeChange"
			  @current-change="handleOrderRecordCurrentChange"
			  layout="total, sizes, prev, pager, next, jumper"
			  :page-sizes="[10, 20, 50, 100]"
			  :current-page="orderRecordCurrent"
			  :page-size="orderRecordSize"
			  :total="orderRecordTotal"
			  style="margin-top: 20px; float: right;">
			</el-pagination>

			<div slot="footer" style="margin-top: 10px;" class="dialog-footer">
				<el-button @click="handleOrderRecordClose">关 闭</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
import { getCustomerList, updatePoints, getPointsDetailList, testPushMessage } from '@/apis/customer'
import { getRecordes, getOrderInfo } from '@/apis/devices'
import * as echarts from 'echarts';
import dayjs from 'dayjs'
export default {
	name: "Customer",	// 客户管理
	data() {
		return {
			loading: true,

			searchForm: {},
			showTuisong: false,
			clickCount: 0,
			lastClickTime: 0,

			total: 0,
			size: 10,
			current: 1,

			dialogVisible: false,
			title: '新增',
			editForm: {},

			tableData: [],

			jfDialogVisible: false,
			jfTitle: '结余时间操作',
			jfForm: {
				type: '发放'
			},
			jfFormRules: {
				type: [
					{required: true, message: '请选择类型', trigger: 'blur'}
				],
				points: [
					{required: true, message: '请输入结余时间', trigger: 'blur'}
				],
				remark: [
					{required: false, message: '请输入备注', trigger: 'blur'}
				]
			},

			multipleSelection: [],

			permDialogVisible: false,
			permForm: {},
			defaultProps: {
				children: 'children',
				label: 'machineNum'
			},
			treeSelectLocationId: 0,
			selectedMachineInfo: '',

			// 结余时间明细相关
			detailDialogVisible: false,
			detailTitle: '结余时间明细',
			detailLoading: false,
			detailTableData: [],
			detailSearchForm: {},
			detailDateRange: [],
			detailCurrent: 1,
			detailSize: 10,
			detailTotal: 0,
			currentOpenid: '', // 当前查看明细的用户openid

			// 订单详情弹窗相关
			orderDetailDialogVisible: false,
			orderDetail: null, // 订单详情数据
			clickRow: null, // 点击的行数据
			showPowerChart: false, // 是否显示功率图表
			powerChartInstance: null, // 图表实例

			// 订单记录弹窗相关
			orderRecordDialogVisible: false,
			orderRecordTitle: '订单记录',
			orderRecordLoading: false,
			orderRecordTableData: [],
			orderRecordSearchForm: {},
			orderRecordDate: null,
			orderRecordCurrent: 1,
			orderRecordSize: 10,
			orderRecordTotal: 0,
			currentOrderRecordOpenid: '', // 当前查看订单记录的用户openid

			reasonArr: [
				{value: 0 , label: '充电时间/电量用完了'},
				{value: 1 , label: '充满了或充电功率低'},
				{value: 2 , label: '充电满了，自动停止'},
				{value: 3 , label: '充电结束'},
				{value: 4 , label: 'D功率过大，充电结束'},
				{value: 5 , label: '刷卡退费结束'},
				{value: 6 , label: '充电功率低停止充电'},
				{value: 7 , label: '系统关机'},
				{value: 8 , label: '烟雾报警停止'},
				{value: 9 , label: '过压'},
				{value: 10, label:  '欠压'},
				{value: 11, label:  '高温'},
				{value: 12, label:  'Z功率过大，充电结束'},
				{value: 13, label:  '因固件升级，充电结束'},
				{value: 14, label:  '强磁'},
				{value: 15, label:  '功率过大/短路'},
				{value: 71, label:  '管理后台结束充电'},
				{value: 72, label:  '商户后台结束充电'},
				{value: 73, label:  '用户手动结束充电'},
				{value: 88, label:  '充电费用用完了'},
				{value: 98, label:  '开机失败'},
				{value: 99, label:  '充电结束。'},
			]
		}
	},
	computed: {
		tableHeight: function () {
			return screen.height > 900 ? 630 : 550
		}
	},
	mounted() {
		this.getCustomerList()
	},
	methods: {
		handleSearchToolsTextClick() {
			const now = Date.now()
			// 如果距离上次点击超过2秒，重置计数器
			if (now - this.lastClickTime > 2000) {
				this.clickCount = 0
			}
			this.clickCount++
			this.lastClickTime = now
			
			// 连续点击5次后切换showTuisong
			if (this.clickCount >= 5) {
				this.showTuisong = !this.showTuisong
				this.clickCount = 0 // 重置计数器
			}
		},
		tuisongHandle(row) {
			const loading = this.$loading({
				text: '推送中...',
				lock: true
			});
			testPushMessage({openid: row.openid, title: '测试推送消息', begintime: '2026-01-01 10:00:00', endtime: '2026-01-01 14:00:00', orderno: '202601011234567890', tip: "充电时间用完了"}).then(res => res.data).then(res => {
				if (res.code == 200) {
					this.$message({
						showClose: true,
						message: '推送成功',
						type: 'success'
					});
				} else {
					this.$message({
						showClose: true,
						message: res.message,
						type: 'error'
					});
				}
				loading.close()
			})
		},
		resetSearchForm() {
			this.searchForm = {}
			this.getCustomerList()
		},
		toggleSelection(rows) {
			if (rows) {
				rows.forEach(row => {
					this.$refs.multipleTable.toggleRowSelection(row);
				});
			} else {
				this.$refs.multipleTable.clearSelection();
			}
		},
		handleSelectionChange(val) {
			this.multipleSelection = val;
		},

		handleSizeChange(val) {
			this.size = val
			this.getCustomerList()
		},
		handleCurrentChange(val) {
			this.current = val
			this.getCustomerList()
		},
		resetForm(formName) {
			this.$refs[formName].resetFields();
			this.dialogVisible = false
			this.jfDialogVisible = false
			this.editForm = {}
		},
		handleClose() {
			this.resetForm('editForm')
		},
		handleJfClose() {
			this.resetForm('jfForm')
		},
		pointsHandle(row) {
			this.jfTitle = '结余时间操作 - ' + row.nickname
			this.jfForm = {
				openid: row.openid,
				points: 0,
				type: '发放'
			}
			this.jfDialogVisible = true
		},
		submitJfForm(formName) {
			let _that = this
			this.$refs[formName].validate((valid) => {
				if (valid) {
					if (this.jfForm.points == 0) {
						this.$message({
							showClose: true,
							message: '请输入结余时间',
							type: 'error'
						});
						return false;
					}
					let points = 0
					if (this.jfForm.type == '发放') {
						points = parseInt(this.jfForm.points)
					}
					else {
						points = -parseInt(this.jfForm.points)
					}
					updatePoints({openid: this.jfForm.openid, points: points, remark: this.jfForm.remark || ''}).then(res => res.data).then(res => {
						if (res.code == 200) {
							this.$message({
								showClose: true,
								message: '操作成功',
								type: 'success',
							});
							_that.getCustomerList()
							_that.jfDialogVisible = false
						}
					})
				}
				else {
					return false;
				}
			});
		},
		getCustomerList() {
			this.loading = true
			getCustomerList({page: this.current, pageSize: this.size, ...this.searchForm}).then(res => res.data).then(res => {
				console.log(res);
				this.tableData = res.data.list
				this.total = res.data.total
				this.loading = false
			})
		},

		submitForm(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					// console.log(this.editForm);
					if (this.editForm.id) {
						updateApi({...this.editForm, quota: parseFloat(this.editForm.quota)}).then(res => {
							this.$message({
								showClose: true,
								message: '操作成功',
								type: 'success',
								onClose: () => {
									this.getpe()
								}
							});
							this.dialogVisible = false
						  	this.resetForm(formName)
						})
					} else {
						addApi({...this.editForm, quota: parseFloat(this.editForm.quota)}).then(res => {
							this.$message({
								showClose: true,
								message: '操作成功',
								type: 'success',
								onClose: () => {
									this.getpe()
								}
							});
							this.dialogVisible = false
						  	this.resetForm(formName)
						})
					}
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
		addHandle() {
			this.editForm = {}
			this.title = '新增'
			this.dialogVisible = true
		},
		// 结余时间明细相关方法
		detailHandle(row) {
			this.detailTitle = '结余时间明细 - ' + row.nickname
			this.currentOpenid = row.openid
			this.detailSearchForm = {}
			this.detailDateRange = []
			this.detailCurrent = 1
			this.detailSize = 10
			this.detailDialogVisible = true
			this.getPointsDetailList()
		},
		handleDetailClose() {
			this.detailDialogVisible = false
			this.detailSearchForm = {}
			this.detailDateRange = []
			this.detailTableData = []
			this.currentOpenid = ''
		},
		getPointsDetailList() {
			this.detailLoading = true
			let params = {
				page: this.detailCurrent,
				pageSize: this.detailSize,
				openid: this.currentOpenid
			}
			// 添加日期范围
			if (this.detailDateRange && this.detailDateRange.length === 2) {
				params.startTime = this.detailDateRange[0]
				params.endTime = this.detailDateRange[1]
			}
			// 如果有类型筛选，也可以添加
			if (this.detailSearchForm.type) {
				params.type = this.detailSearchForm.type
			}
			getPointsDetailList(params).then(res => res.data).then(res => {
				// console.log('结余时间明细列表:', res)
				if (res.code == 200) {
					this.detailTableData = res.data.list || res.data.records || []
					this.detailTotal = res.data.total || res.data.totalElements || 0
				} else {
					this.$message({
						showClose: true,
						message: res.msg || '获取结余时间明细失败',
						type: 'error'
					})
					this.detailTableData = []
					this.detailTotal = 0
				}
				this.detailLoading = false
			}).catch(err => {
				console.error('获取结余时间明细失败:', err)
				this.$message({
					showClose: true,
					message: '获取结余时间明细失败',
					type: 'error'
				})
				this.detailLoading = false
				this.detailTableData = []
				this.detailTotal = 0
			})
		},
		searchDetailList() {
			this.detailCurrent = 1
			this.getPointsDetailList()
		},
		resetDetailSearchForm() {
			this.detailSearchForm = {}
			this.detailDateRange = []
			this.detailCurrent = 1
			this.getPointsDetailList()
		},
		handleDetailSizeChange(val) {
			this.detailSize = val
			this.detailCurrent = 1
			this.getPointsDetailList()
		},
		handleDetailCurrentChange(val) {
			this.detailCurrent = val
			this.getPointsDetailList()
		},
		// 订单记录相关方法
		orderRecordHandle(row) {
			this.orderRecordTitle = '订单记录 - ' + row.nickname
			this.currentOrderRecordOpenid = row.openid
			this.orderRecordSearchForm = {}
			this.orderRecordDate = null
			this.orderRecordCurrent = 1
			this.orderRecordSize = 10
			this.orderRecordDialogVisible = true
			this.getOrderRecordList()
		},
		handleOrderRecordClose() {
			this.orderRecordDialogVisible = false
			this.orderRecordSearchForm = {}
			this.orderRecordDate = null
			this.orderRecordTableData = []
			this.currentOrderRecordOpenid = ''
		},
		getOrderRecordList() {
			this.orderRecordLoading = true
			let params = {
				pageNum: this.orderRecordCurrent,
				pageSize: this.orderRecordSize,
				openid: this.currentOrderRecordOpenid
			}
			// 添加日期筛选
			if (this.orderRecordDate) {
				params.date = this.orderRecordDate
			}
			getRecordes(params).then(res => res.data).then(res => {
				if (res.code == 200) {
					this.orderRecordTableData = res.data.list || res.data.records || []
					this.orderRecordTotal = res.data.total || res.data.totalElements || 0
				} else {
					this.$message({
						showClose: true,
						message: res.msg || res.message || '获取订单记录失败',
						type: 'error'
					})
					this.orderRecordTableData = []
					this.orderRecordTotal = 0
				}
				this.orderRecordLoading = false
			}).catch(err => {
				console.error('获取订单记录失败:', err)
				this.$message({
					showClose: true,
					message: '获取订单记录失败',
					type: 'error'
				})
				this.orderRecordLoading = false
				this.orderRecordTableData = []
				this.orderRecordTotal = 0
			})
		},
		searchOrderRecordList() {
			this.orderRecordCurrent = 1
			this.getOrderRecordList()
		},
		resetOrderRecordSearchForm() {
			this.orderRecordSearchForm = {}
			this.orderRecordDate = null
			this.orderRecordCurrent = 1
			this.getOrderRecordList()
		},
		handleOrderRecordSizeChange(val) {
			this.orderRecordSize = val
			this.orderRecordCurrent = 1
			this.getOrderRecordList()
		},
		handleOrderRecordCurrentChange(val) {
			this.orderRecordCurrent = val
			this.getOrderRecordList()
		},
		// 查看订单记录详情
		viewOrderRecordDetail(row) {
			if (!row.chargingOrderNo) {
				this.$message({
					type: 'warning',
					message: '充电订单号不存在，无法查看详情'
				})
				return
			}
			this.getOrderDetail(row)
		},
		// 查看订单详情
		viewDetailHandle(row) {
			if (!row.orderNo) {
				this.$message({
					type: 'warning',
					message: '订单号不存在，无法查看详情'
				})
				return
			}

			const loading = this.$loading({
				text: '加载中...',
				lock: true
			})

			// 调用 getRecordes 接口，传递 orderNo
			getRecordes({
				pageNum: 1,
				pageSize: 10,
				orderNo: row.orderNo
			}).then(res => res.data).then(res => {
				loading.close()
				if (res.code == 200 && res.data && res.data.list && res.data.list.length > 0) {
					// 从返回的数组数据中获取 chargingOrderNo
					const orderItem = res.data.list[0]
					if (orderItem.chargingOrderNo) {
						// 调用 getOrderInfo 获取订单详情
						this.getOrderDetail(orderItem)
					} else {
						this.$message({
							type: 'warning',
							message: '未找到充电订单号'
						})
					}
				} else {
					this.$message({
						type: 'warning',
						message: res.message || '未找到相关订单'
					})
				}
			}).catch(error => {
				loading.close()
				console.error('获取订单列表失败:', error)
				this.$message({
					type: 'error',
					message: '获取订单列表失败，请稍后再试'
				})
			})
		},
		// 获取订单详情
		getOrderDetail(row) {
			this.clickRow = row
			this.showPowerChart = false
			if (this.powerChartInstance) {
				this.powerChartInstance.dispose()
				this.powerChartInstance = null
			}

			if (!row.chargingOrderNo) {
				this.$message({
					type: 'warning',
					message: '充电订单号不存在，无法查看详情'
				})
				return
			}

			const loading = this.$loading({
				text: '加载订单详情...',
				lock: true
			})

			getOrderInfo({
				orderNo: row.chargingOrderNo
			}).then(res => res.data).then(res => {
				loading.close()
				if (res.code == 200 && res.data) {
					this.orderDetail = res.data.data
					this.orderDetailDialogVisible = true
				} else {
					this.$message({
						type: 'error',
						message: res.message || '获取订单详情失败'
					})
				}
			}).catch(error => {
				loading.close()
				console.error('获取订单详情失败:', error)
				this.$message({
					type: 'error',
					message: '获取订单详情失败，请稍后再试'
				})
			})
		},
		// 关闭订单详情弹窗
		closeOrderDetailDialog() {
			this.orderDetailDialogVisible = false
			this.orderDetail = null
			this.clickRow = null
			this.showPowerChart = false
			if (this.powerChartInstance) {
				this.powerChartInstance.dispose()
				this.powerChartInstance = null
			}
		},
		// 格式化金额（分转元）
		formatAmount(amount) {
			if (!amount && amount !== 0) return '0.00'
			amount = amount / 100
			return parseFloat(amount).toFixed(2)
		},
		// 计算已充电时长 (分钟)
		getChargedDuration() {
			if (!this.orderDetail || !this.orderDetail.start_date) return 0
			const start = dayjs(this.orderDetail.start_date)
			const now = dayjs()
			const diff = now.diff(start, 'minute')
			return diff > 0 ? diff : 0
		},
		// 计算剩余时长 (分钟)
		getRemainingDuration() {
			const charged = this.getChargedDuration()
			const total = Number(this.clickRow.chargingMinutes) || 0
			const remaining = total - charged
			return remaining > 0 ? remaining : 0
		},

		togglePowerChart() {
			this.showPowerChart = !this.showPowerChart;
			if (this.showPowerChart) {
				this.$nextTick(() => {
					this.initPowerChart();
				});
			} else {
				if (this.powerChartInstance) {
					this.powerChartInstance.dispose();
					this.powerChartInstance = null;
				}
			}
		},

		initPowerChart() {
			if (!this.orderDetail || !this.orderDetail.powers || this.orderDetail.powers.length === 0) {
				this.$message.info('暂无功率数据');
				this.showPowerChart = false;
				return;
			}
			const Arr = JSON.parse(JSON.stringify(this.orderDetail.powers));
			// Arr.reverse()
			Arr.sort((a, b) => parseInt(a.create_time) - parseInt(b.create_time));

			const chartDom = this.$refs.powerChart;
			if (this.powerChartInstance) {
				this.powerChartInstance.dispose();
			}
			this.powerChartInstance = echarts.init(chartDom);

			const option = {
				title: {
					text: '实时功率曲线',
					left: 'center'
				},
				tooltip: {
					trigger: 'axis'
				},
				xAxis: {
					type: 'category',
					data: Arr.map(item => item.create_time_str),
					axisLabel: {
						rotate: 45, // Rotate labels to prevent overlap
						interval: 'auto'
					}
				},
				yAxis: {
					type: 'value',
					name: '功率 (W)',
					axisLabel: {
						formatter: '{value} W'
					}
				},
				series: [
					{
						name: '功率',
						type: 'line',
						data: Arr.map(item => item.instand_power),
						smooth: true
					}
				],
				grid: {
					left: '10%',
					right: '10%',
					bottom: '15%'
				},
				dataZoom: [ // Add data zoom for better navigation on long time series
					{
						type: 'inside',
						start: 0,
						end: 100
					},
					{
						start: 0,
						end: 100
					}
				],
			};
			this.powerChartInstance.setOption(option);
		},
	}
}
</script>

<style scoped>

.el-pagination {
	float: right;
	margin-top: 22px;
}

.el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 100%;
}

.el-select {
	width: 96%;
}

.btn {
	display: flex;
	justify-content: right;

	/* .el-button:first-child {
		margin-right: 30px;
	} */
}
.border {
	width: 40px;
	height:40px;
	text-align: center; 
	line-height: 40px;
	border-radius: 50%;
	display: inline-block;
	cursor: pointer;
}
.green {
	border: 1px solid green;
	color: green;
}
.red {
	border: 1px solid red;
	color: red;
}

/* 订单详情弹窗样式 */
.order-detail-container {
	padding: 10px 0;
}

.detail-section {
	margin-bottom: 30px;
	padding: 20px;
	background: #f8f9fa;
	border-radius: 8px;
	border-left: 4px solid #409EFF;
}

.section-title {
	display: flex;
	align-items: center;
	font-size: 16px;
	font-weight: 600;
	color: #303133;
	margin-bottom: 20px;
	padding-bottom: 10px;
	border-bottom: 2px solid #e4e7ed;
}

.section-title i {
	font-size: 18px;
	margin-right: 8px;
	color: #409EFF;
}

.detail-row {
	margin-bottom: 15px;
}

.detail-row:last-child {
	margin-bottom: 0;
}

.detail-item {
	display: flex;
	align-items: center;
	min-height: 32px;
}

.detail-label {
	font-size: 14px;
	color: #606266;
	font-weight: 500;
	min-width: 120px;
	flex-shrink: 0;
}

.detail-value {
	font-size: 14px;
	color: #303133;
	flex: 1;
	word-break: break-all;
}

.detail-value.highlight {
	color: #409EFF;
	font-weight: 600;
	font-size: 15px;
}
</style>